import { render, staticRenderFns } from "./DueDiligenceTitle.vue?vue&type=template&id=3b2c6ce1&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b2c6ce1')) {
      api.createRecord('3b2c6ce1', component.options)
    } else {
      api.reload('3b2c6ce1', component.options)
    }
    module.hot.accept("./DueDiligenceTitle.vue?vue&type=template&id=3b2c6ce1&", function () {
      api.rerender('3b2c6ce1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/forms/due-diligence/DueDiligenceTitle.vue"
export default component.exports